import "./index.css";
import React, { lazy, Suspense } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";

// const Dashobard = lazy(() => import('./pages/DashboardPage'))
import Dashobard from './pages/DashboardPage'
const Ticket = lazy(() => import('./pages/ticket'))
import AuthPage from "./pages/Register";
// import LiquidChrome from "./components/LiquidChrome";
import Login from "./pages/Login";
import { isLoggedIn } from "./lib/utils";

// import holi_video from './images/holi_video.mp4'
import holi_bg from './images/area_paln_bg.png'
// import holi_bg from './images/background.png'
import holi_img from './images/holi-img.jpg'

const HoliLayout = () => {
  return (
    <div style={{ background: "#fff" }}>
      <div>
        <img
          class="video-bg"
          src={holi_bg} 
        />
        <div className="backdrop"></div>
      </div>

      <Outlet />

      <style>{`
        .video-bg {
          position: absolute;
          top: 0;
          left: 0;
          // width: 100dvw;
          // height: 100dvh;
          object-fit: contain; /* important */
        }

        .content {
          position: relative;
          z-index: 1;
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          color: white;
          text-align: center;
          background: rgba(0,0,0,0.4); /* optional overlay */
        }

        .backdrop {
          position: absolute;
          top: 0;
          left: 0;
          width: 100vw;
          height: 70dvh;
          z-index: 0;
          background: linear-gradient(0deg, #ffffff, transparent)
        }
      `} </style>
    </div>
  )
}

const AdminLayout = () => {
  return(
    <div>
      <div style={{ position:"fixed", top: 0, left: 0, width: "100vw", height: "100dvh", zIndex: -1 }}>
        <img src={holi_img} width={"100%"} height={"100%"} style={{ filter: "brightness(0.3)"}}/>
      </div>
      <Outlet />
    </div>
  )
}


const ProtectRoute = (Component) => {
  if (isLoggedIn()) return Component
  return <Navigate to={"/admin/login"} />
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HoliLayout />}>
        <Route path="/" element={<AuthPage />} />
        <Route path="/ticket" element={<Ticket />} />
        <Route path="/ticket/:regId" element={<Ticket />} />
        <Route path="/*" element={<Navigate to={'/'} />} />
      </Route>

      <Route path="/admin" element={<AdminLayout />}>
        <Route path="/admin/" element={ProtectRoute(<Dashobard />)} />
        <Route path="/admin/dashboard" element={ProtectRoute(<Dashobard />)} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin/*" element={<Navigate to={'/admin/login'} />} />
      </Route>

    </Routes>
  );
}

function App() {
  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        width: "100vw",
        overflow: "hidden",
      }}
    >
      <BrowserRouter>
        <Suspense>
          <AppRoutes />
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
